export const DocumentType = {
    patientProfileImage: 1,
    doctorProfileImage: 2,
    userPhotoIdImage: 3,
    userInsuranceFrontImage: 4,
    userInsuranceBackImage: 5
}

export const QuestionType = {
    boolean: 1,
    textInput: 2,
    numberInput: 3,
    multipleChoice:4,
    checkboxes:5,
    Meds: 6 || 10 ,
    search: 9,
    height: 7,
    weight: 8,
    weight: 10,
    fileUpload: 11 || 12 || 13,
    BooleanQuesTypeWidget:14,
    mailing:15 || 16,

}

// [  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,  12, 13, 14, 15, 16, ]



// switch (questionType) {
//     case 1:
//       return CustomBooleanQuesTypeWidget;

//     case 2:
//       return CustomTextFieldQuesTypeWidget;

//     case 3:
//       return CustomNumberQuesTypeWidget;

//     case 4:
//       return CustomOptionsQuesTypeWidget;

//     case 5:
//       return CustomCheckBoxQuesTypeWidget;

//     case 6:
//       return CustomMedsQuesTypeWidget;

//     case 10:
//       return CustomMedsQuesTypeWidget;

//     case 7:
//       return CustomHeightQuesTypeWidget;

//     case 8:
//       return CustomWeightQuesTypeWidget;
//     case 9:
//       return CustomSearchQuesTypeWidget;

//     case 11:
//       return CustomUploadDocsQuestionTypeWidget;

//     case 12:
//       return CustomUploadDocsQuestionTypeWidget;

//     case 13:
//       return CustomUploadDocsQuestionTypeWidget;
//     case 14:
//       return CustomBooleanQuesTypeWidget;

//     case 15:
//       return CustomMailOrderQuesTypeWidget;

//     case 16:
//       return CustomMailOrderQuesTypeWidget;

//     default:
//       return const Text('NAN');
//   }